export const SignatureFlowEnum = {
    AND: "AND",
    OR: "OR",
    SEQUENCE: "SEQUENCE",
    INPERSONSIGNING: "INPERSONSIGNING"
};